export default __webpack_public_path__ + "static/media/filter.6418c7ef.svg";